import { Building2 } from 'lucide-react';

export default function Companies() {
  return (
    <div className="page-enter">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 'var(--space-6)',
        }}
      >
        <h1 className="page-title">Companies</h1>
        <button
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--space-2)',
            padding: 'var(--space-2) var(--space-4)',
            borderRadius: 'var(--radius-md)',
            background: 'var(--color-brand)',
            color: 'var(--color-text-inverse)',
            fontSize: 'var(--text-sm)',
            fontWeight: 'var(--weight-medium)',
            cursor: 'pointer',
          }}
        >
          + Add company
        </button>
      </div>

      {/* Empty state */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'var(--space-16) var(--space-8)',
          textAlign: 'center',
          border: '1px dashed var(--color-border)',
          borderRadius: 'var(--radius-xl)',
          color: 'var(--color-text-muted)',
        }}
      >
        <Building2 size={48} style={{ marginBottom: 'var(--space-4)', opacity: 0.4 }} />
        <h2
          style={{
            fontSize: 'var(--text-lg)',
            fontWeight: 'var(--weight-medium)',
            color: 'var(--color-text-secondary)',
            marginBottom: 'var(--space-2)',
          }}
        >
          No companies yet
        </h2>
        <p style={{ fontSize: 'var(--text-sm)', maxWidth: 320 }}>
          Add your first company to start tracking your relationships.
        </p>
      </div>
    </div>
  );
}
